// `/market/experts/$handle` — one expert. The parent owns the build-master
// gate; the lazy child enables its query only from the server capability DTO.
//
// An unpublished profile answers from the gateway byte-for-byte like a handle
// that names nobody, unless the caller owns the account it belongs to.
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/market/experts/$handle')({});
